import { createLogger } from "@offstreetparking/logger";
import { env } from "./env";

export const serverLogger = createLogger({ service: env.NEXT_PUBLIC_SERVICE });
